import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  cardContainerStyle: theme => ({
    paddingVertical: 16.6,
    paddingBottom: 8,
    marginHorizontal: 16.5,
    marginBottom: 18,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    ...cardShadow,
  }),
  marginHorizontal: {
    marginHorizontal: 20,
  },
  footerTextStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
    color: Colors.blackTwo,
    marginVertical: 5,
  },
  iconsArrayStyle: {
    marginLeft: -7,
    marginBottom: 10,
  },
  mainSection: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  topText: {
    fontSize: 20.8,
    lineHeight: 25,
    color: Colors.blackTwo,
    ...Fonts.type.bold,
  },
  mainSectionText: {
    marginEnd: 70,
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: Colors.veryLightPinkTwo,
    marginVertical: 12,
  },
  icon: { marginEnd: 8.3 },
  userContainer: { width: '100%' },
  viewDetailsStyle: {
    color: Colors.red,
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  licencesCountTextStyle: {
    color: Colors.blackTwo,
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  viewDetailsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 6,
  },
  btnTextStyle: {
    fontSize: 18.7,
    width: 200,
    marginHorizontal: 60,
  },
  btnContainer: { marginTop: 10 },
  btnStyle: { marginBottom: 16.6 },
  marginVertical: {
    marginVertical: 17,
  },
});
